import React from "react";

export const PublicRoute = ({component: Component, additionalProps}) => {
    return <Component {...additionalProps}/>
}